module.exports = __webpack_public_path__ + "img/lu.ee943372.svg";